import { required } from "vuelidate/lib/validators";
 
const StrIsoIcTetkik = {
  data() {
    return {
      StrIsoIcTetkikData: {
        Yer: null,
        Acilistarih: null,
        Birimid: null, 
        Uygunsuzluklar: "[]",
        Gelisimeacikyonler: "[]",
        Kuvvetliyonler: "[]",
        Birimpersonelleriids: [],
        Ictetkikciids: [],

        
      },
      FormDataType: { 
        Yer: { FieldName: "Yer", Field: "textarea", FieldTitle: "Yer", FieldType: "text" },
        Birimid: { FieldName: "Birimid", Field: "combobox", FieldTitle: "Birim", ComboDataArray: [] }, 
        Yil: { FieldName: "Yil", Field: "combobox", FieldTitle: "Yıl", ComboDataArray: [ ] }, 
      }, 
    }
  },
  validations: {
    FormData: {
      Yer: { required },
      Birimid: { required }, 
    },
    Filter:{ 
      Birimid: {}, 
      Yil: {}
    }
  },
  created() { 
    const currentYear = new Date().getFullYear();

    for (let i = currentYear - 5; i <= currentYear + 5; i++) {
      this.FormDataType.Yil.ComboDataArray.push({ Id: i, Value: i });
    }
    
  }
}
export default StrIsoIcTetkik